export enum MatchRule {
  ANY = "ANY",
  ALL = "ALL"
}
